export default __webpack_public_path__ + "static/media/favorites-strong.3e64576e.png";